import DashboardSingleScanMap from "./dashboardSingleScanMap.container";

export default DashboardSingleScanMap;
